import './chat.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ChatList } from './ChatList';
import { ChatView } from './ChatView';

// Seiten unter /app/nachrichten: Liste der Ansprechpartner und ein Chat je Ansprechpartner und Firma.
export function ChatRoutes() {
  return (
    <Routes>
      <Route index element={<ChatList />} />
      <Route path=":clientId/:staffId" element={<ChatView />} />
      <Route path="*" element={<Navigate to="/app/nachrichten" replace />} />
    </Routes>
  );
}
